// extracted by mini-css-extract-plugin
module.exports = {"tcoButton":"_3DNOct"};